export function measureStatusReveal(from, to) {
  if (!from || !to || !from.width || !from.height) return { x: 0, y: 0, scaleX: 1, scaleY: 1 };
  return {
    x: to.left - from.left,
    y: to.top - from.top,
    scaleX: to.width / from.width,
    scaleY: to.height / from.height,
  };
}
